export default __webpack_public_path__ + "static/media/coursera.ca4747d2.svg";